
























    import Vue from 'Vue';
    import Vuex from 'Vuex';
    import { INavigationButton, ThemeEnum, ButtonSizeEnum } from '../../../../../../CommonScripts/Abstractions';
    export default Vue.extend({
        name: 'c-toolstrip-item',
        props: {
            contentButtonConfig: { type: Object as () => INavigationButton, required: true }
        },
        computed: {
            dark(): boolean { return this.contentButtonConfig.theme === ThemeEnum.Dark; },
            light(): boolean { return this.contentButtonConfig.theme === ThemeEnum.Light; },
            small(): boolean { return this.contentButtonConfig.size === ButtonSizeEnum.Small; },
            large(): boolean { return this.contentButtonConfig.size === ButtonSizeEnum.Large; },
            btnAriaLabel(): string { return this.$vuetify.lang.t(this.contentButtonConfig.ariaLabelKey); },
            btnTooltip(): string { return this.$vuetify.lang.t(this.contentButtonConfig.tooltipKey); },
            iconClass(): string {
                    return this.$store.getters['textCssClass'];
            },
            cssClasses(): string {
                return `mr-2 ${this.contentButtonConfig.cssClasses}`;
            }
        },
        methods: {
            clickHandler() {
                if (this.contentButtonConfig.clickHandler)
                    this.contentButtonConfig.clickHandler();
            }
        }
    });
